// nav-mode.js — User view or Customer view (D9, the AudienceToggle in the top bar).
// App.jsx owns the value; ViewSwitcher reads it to decide which menu to offer.
import { createContext } from 'react';

export const NavModeContext = createContext({ customer: false });
